<template>
  <v-container>
    <v-layout row wrap>
      <v-flex lg12 md12 sm12 xs12 :class="['pa-2']">
        <static-page-content slug="videos" />
      </v-flex>
    </v-layout>
    <template v-if="categories && videos.length">
      <video-category v-for="(video, index) in videos" :key="index" :videos="categories[video]" :class="[index > 0 ? 'mt-2' : null]" />
    </template>
    <news-ticker />
  </v-container>
</template>
<script>
import methods from '../mixins/methods'
import VideoCategory from '../components/video-category'

export default {
  name: 'PageVideos',
  components: {
    VideoCategory
  },
  mixins: [
    methods
  ],
  data () {
    return {
      categories: null,
      videos: []
    }
  },
  mounted () {
    this.getVideoCategories()
  },
  methods: {
    setVideos (data) {
      const categories = {}
      data.forEach(video => {
        const album = video.album
        const slug = this.makeSlug(album)
        video.slug = slug
        if (!categories[album]) {
          categories[slug] = []
        }
      })
      Object.keys(categories).forEach(album => {
        categories[album] = data.filter(video => video.slug === album && video.inList)
      })
      this.categories = categories
    },
    getVideos () {
      const url = this.getRoute('videos').url
      const slug = this.$route.path
      const cachedData = this.retrieveCachedData('videos', slug)
      if (cachedData) {
        return this.setVideos(cachedData)
      }
      this.$http({
        url
      }).then(response => {
        const data = response.data.data
        this.setVideos(data)
        this.cacheData(slug, 'videos', data)
      }).catch(error => {
        console.error(error)
      })
    },
    getVideoCategories () {
      const url = this.getRoute('video-categories').url
      this.$http({url}).then(response => {
        this.videos = response.data.data
        this.$nextTick(() => {
          this.getVideos()
        })
      }).catch(error => {
        console.error(error)
      })
    }
  }
}
</script>
<style>
.videos-list iframe
{
  display: block;
  border: 0;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/pages/videos.vue